import React from 'react';
import { TrendingUp, Zap, DollarSign, Bot } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const ImpactSection = () => {
  const { t } = useLanguage();

  const stats = [
    {
      icon: TrendingUp,
      valueKey: 'impact.stat1.value',
      labelKey: 'impact.stat1.label',
      descKey: 'impact.stat1.description',
      color: 'bg-yellow-400',
      textColor: 'text-yellow-500'
    },
    {
      icon: Zap,
      valueKey: 'impact.stat2.value',
      labelKey: 'impact.stat2.label',
      descKey: 'impact.stat2.description',
      color: 'bg-yellow-400',
      textColor: 'text-yellow-500'
    },
    {
      icon: DollarSign,
      valueKey: 'impact.stat3.value',
      labelKey: 'impact.stat3.label',
      descKey: 'impact.stat3.description',
      color: 'bg-yellow-400',
      textColor: 'text-yellow-500'
    },
    {
      icon: Bot,
      valueKey: 'impact.stat4.value',
      labelKey: 'impact.stat4.label',
      descKey: 'impact.stat4.description',
      color: 'bg-yellow-400',
      textColor: 'text-yellow-500'
    }
  ];

  return (
    <section id="impact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-yellow-400 text-gray-900 rounded-full text-sm font-bold mb-4">
            {t('impact.badge')}
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('impact.title')}{' '}
            <span className="text-yellow-500">
              {t('impact.titleHighlight')}
            </span>
          </h2>
        </div>

        {/* Stats Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const IconComponent = stat.icon;
            return (
              <div
                key={index}
                className="relative overflow-hidden rounded-3xl p-8 bg-white border-2 border-gray-100 hover:border-yellow-400 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group"
              >
                {/* Background Decoration */}
                <div className="absolute -top-10 -right-10 w-32 h-32 bg-yellow-400 rounded-full opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
                
                {/* Icon */}
                <div className={`w-16 h-16 rounded-2xl ${stat.color} flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                  <IconComponent className="h-8 w-8 text-gray-900" />
                </div>
                
                {/* Value */}
                <div className={`text-5xl font-bold mb-2 ${stat.textColor}`}>
                  {t(stat.valueKey)}
                </div>
                
                {/* Label */}
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {t(stat.labelKey)}
                </h3>
                
                {/* Description */}
                <p className="text-gray-600 text-sm leading-relaxed">
                  {t(stat.descKey)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
